import React, { useState } from "react";
import styles from "./validate-account-otp-modal.module.scss";
import OtpInput from "../Input/OtpInput";
import CircularProgress from "@mui/material/CircularProgress";

type ValidateAccountOtpModalProps = {
  onClose: () => void;
  maskedContact: string;
  isVerifying?: boolean;
  onVerify: (otp: string) => void;
  onResend: () => void;
};

const ValidateAccountOtpModal = ({
  onClose,
  maskedContact,
  isVerifying = false,
  onVerify,
  onResend,
}: ValidateAccountOtpModalProps) => {
  const [otp, setOtp] = useState("");
  const canSubmit = otp.length === 6 && !isVerifying;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.close} onClick={onClose}>
          ✕
        </button>

        <span className={styles.text}>
          {`Kindly input the 6 digit OTP code we sent to your email: ${maskedContact}.`}
        </span>

        <OtpInput value={otp} onChange={setOtp} onResend={onResend} />

        <button
          type="button"
          className={styles.button}
          style={{
            backgroundColor: canSubmit
              ? "rgba(13, 96, 13, 1)"
              : "rgba(13, 96, 13, 0.5)",
          }}
          disabled={!canSubmit}
          onClick={() => onVerify(otp)}
        >
          {isVerifying ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            "Continue"
          )}
        </button>
      </div>
    </div>
  );
};

export default ValidateAccountOtpModal;
